import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { trpc } from '@/lib/trpc';
import { LegalPage } from './-components/legal-page';
import { slugs } from './privacy-policy.meta';

export const Route = createFileRoute('/www/privacy-policy')({
	loader: ({ context }) => {
		context.queryClient.prefetchQuery(
			trpc.core.getLegalContent.queryOptions({ type: 'privacy-policy', locale: context.locale }),
		);
	},
	component: Component,
});

function Component() {
	const { t } = useLingui();
	return (
		<LegalPage
			type="privacy-policy"
			slugs={slugs}
			title={t`Privacy Policy - Worldcoo`}
			description={t`How Worldcoo collects, uses and protects the personal data of the people who use its website and its donation services.`}
		/>
	);
}
